module.exports = __webpack_public_path__ + "static/img/main.950bc62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/6/main.png
// module id = KPJ1
// module chunks = 1